module.exports = __webpack_public_path__ + "static/media/  (130).63938e10.jpg";